import { useEffect } from "react";
import { observer } from "mobx-react";
import { Box, Grid } from "@mui/material";
import SummaryCard from "../components/SummaryCard";
import EQ5DLSummary from "../components/summary/EQ5D5LSummary";
import SymptomDiarySummary from "../components/summary/SymptomDiaryDetails";
import AntibioticsSummary from "../components/summary/AntibioticsSummary";
import ImmunoglobulinSummary from "../components/summary/ImmunoglobulinSummary";
import SickDaysSummary from "../components/summary/SickDaysSummary";
import CareDaysSummary from "../components/summary/CareDaysSummary";
import VaccinationSummary from "../components/summary/VaccinationSummary";
import MyNotesSummary from "../components/summary/MyNotesSummary";
import { useStoreContext } from "..";
import ReadMoreInfo from "../components/ReadMoreInfo";

const Home = observer(() => {
  const { routerStore, fieldStore, formStore, userStore } = useStoreContext();

  useEffect(() => {
    if (!formStore.forms) {
      formStore.getForms();
    }
  }, [formStore.forms]);

  useEffect(() => {
    if (!fieldStore.fields) {
      fieldStore.getFields();
    }
  }, [fieldStore.fields]);

  return (
    <Box
      className="page-container"
      sx={{ marginBottom: userStore.isIphoneUser ? 8 : 0 }}
    >
      <Box sx={{ marginBottom: 2 }}>
        <ReadMoreInfo
          text="Välkommen till Hälsodagboken!"
          moreText="Här kan du registrera uppgifter som hör samman med din immunbrist och/eller infektionsbenägenhet. Alla uppgifter förutom kommentarerna förs över till kvalitetsregistret PIDcare och kan där ses av din läkare och sjuksköterska. Att få en samlad bild av dina symtom/behandling/uppskattat hälsotillstånd etc. är viktig för att utvärdera att du får den bästa vården baserat på hur just du mår."
          moreMoreText="Mer information om hur du fyller i Hälsodagboken finns under varje avsnitt. Personalen på din immunbristmottagning kan hjälpa till om du har frågor om hur du använder Hälsodagboken."
        />
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} lg={4}>
          <SummaryCard
            contentBackgroundColor="#007788"
            onLinkClicked={() => routerStore.history.push("/EQ-5D-5L")}
          >
            <EQ5DLSummary />
          </SummaryCard>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <SummaryCard
            contentBackgroundColor="#f44236"
            onLinkClicked={() => routerStore.history.push("/symptomdiary")}
          >
            <SymptomDiarySummary />
          </SummaryCard>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <SummaryCard
            contentBackgroundColor="#ff9700"
            onLinkClicked={() => routerStore.history.push("/antibiotics")}
          >
            <AntibioticsSummary />
          </SummaryCard>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <SummaryCard
            contentBackgroundColor="#4cb050"
            onLinkClicked={() => routerStore.history.push("/immunoglobulin")}
          >
            <ImmunoglobulinSummary />
          </SummaryCard>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <SummaryCard
            contentBackgroundColor="#ea1e63"
            onLinkClicked={() => routerStore.history.push("/sickdays")}
          >
            <SickDaysSummary />
          </SummaryCard>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <SummaryCard
            contentBackgroundColor="#ad1457"
            onLinkClicked={() => routerStore.history.push("/caredays")}
          >
            <CareDaysSummary />
          </SummaryCard>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <SummaryCard
            contentBackgroundColor="#ffeb3c"
            onLinkClicked={() => routerStore.history.push("/vaccination")}
          >
            <VaccinationSummary />
          </SummaryCard>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <SummaryCard
            contentBackgroundColor="#007788"
            onLinkClicked={() => routerStore.history.push("/mynotes")}
          >
            <MyNotesSummary />
          </SummaryCard>
        </Grid>
      </Grid>
    </Box>
  );
});

export default Home;
